document.addEventListener('DOMContentLoaded', function () {
  function toIsoDate(date) {
    return [date.getFullYear(), String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0')].join('-');
  }

  function parseBlockedDates(value) {
    return new Set((value || '').match(/\d{4}-\d{2}-\d{2}/g) || []);
  }

  function splitLabels(value) {
    return (value || '').split('|').map(function (label) { return label.trim(); });
  }

  function formatTemplate(template, replacements) {
    return Object.keys(replacements).reduce(function (result, key) {
      return result.split('{' + key + '}').join(replacements[key]);
    }, template || '');
  }

  document.querySelectorAll('[data-dsp-demo-calendar]').forEach(function (calendar) {
    var days = calendar.querySelector('[data-calendar-days]');
    var monthLabel = calendar.querySelector('[data-calendar-month]');
    var selected = calendar.querySelector('[data-selected-date]');
    var selectedDetail = calendar.querySelector('[data-selected-detail]');
    var input = calendar.querySelector('[data-date-input]');
    var tourFormatInput = calendar.querySelector('[data-tour-format-input]');
    var expectedTime = calendar.dataset.expectedTime || '';
    var submit = calendar.querySelector('[data-calendar-submit]');
    var previous = calendar.querySelector('[data-calendar-previous]');
    var next = calendar.querySelector('[data-calendar-next]');
    var nextPrompt = calendar.querySelector('[data-calendar-next-prompt]');
    if (!days || !monthLabel || !selected || !submit || !previous || !next) return;

    var today = new Date(); today.setHours(0, 0, 0, 0);
    var firstVisibleMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    var monthsAhead = Math.max(1, Number(calendar.dataset.bookingMonths || 12));
    var lastBookableDate = new Date(today.getFullYear(), today.getMonth() + monthsAhead, 0);
    var availabilityUrl = calendar.dataset.availabilityUrl;
    var remoteAvailabilityState = availabilityUrl ? 'loading' : 'ready';
    var viewedMonth = new Date(firstVisibleMonth);
    var allowedWeekdays = (calendar.dataset.allowedWeekdays || 'true,true,true,true,true,true,false')
      .split(',').map(function (value) { return value.trim() === 'true'; });
    var staticBlockedDates = parseBlockedDates(calendar.dataset.blockedDates);
    var remoteBlockedDates = new Set();
    var selectedDate = null;
    var selectedFormat = 'in_person';
    var formatLabels = {
      in_person: calendar.dataset.inPersonLabel || '',
      virtual: calendar.dataset.virtualLabel || ''
    };
    var statusLabels = splitLabels(calendar.dataset.statusLabels);
    var availabilityMessages = splitLabels(calendar.dataset.availabilityMessages);
    var accessibilityLabels = splitLabels(calendar.dataset.accessibilityLabels);
    var selectDateHeading = calendar.dataset.selectDateHeading || '';
    var defaultDetailTemplate = calendar.dataset.defaultDetailTemplate || '';
    var inPersonDetailTemplate = calendar.dataset.inPersonDetailTemplate || '';
    var virtualDetailTemplate = calendar.dataset.virtualDetailTemplate || '';
    var submitTemplate = calendar.dataset.submitTemplate || '';
    var nextMonthTemplate = calendar.dataset.nextMonthTemplate || '';
    var defaultButtonLabel = submit.dataset.buttonLabel || submit.textContent.trim();

    function isSameDate(a, b) {
      return a && b && a.getTime() === b.getTime();
    }

    function isCurrentMonth() {
      return viewedMonth.getFullYear() === today.getFullYear() && viewedMonth.getMonth() === today.getMonth();
    }

    function isAvailable(date) {
      var iso = toIsoDate(date);
      return date >= today && date <= lastBookableDate && allowedWeekdays[date.getDay()] && !staticBlockedDates.has(iso) && !remoteBlockedDates.has(iso);
    }

    function updateFormat(format) {
      selectedFormat = format;
      calendar.querySelectorAll('[data-tour-format]').forEach(function (option) {
        var isSelected = option.dataset.tourFormat === format;
        option.classList.toggle('is-selected', isSelected);
        option.setAttribute('aria-checked', isSelected ? 'true' : 'false');
      });
      if (tourFormatInput) tourFormatInput.value = selectedFormat;
      updateSelectionCopy();
    }

    function updateSelectionCopy() {
      if (!selectedDate) {
        selected.textContent = selectDateHeading;
        if (selectedDetail) selectedDetail.textContent = formatTemplate(defaultDetailTemplate, { time: expectedTime });
        submit.textContent = defaultButtonLabel;
        submit.disabled = true;
        return;
      }
      var readableDate = selectedDate.toLocaleDateString(undefined, { weekday: 'long', month: 'long', day: 'numeric' });
      selected.textContent = formatLabels[selectedFormat] + ' · ' + readableDate;
      if (remoteAvailabilityState !== 'ready') {
        if (selectedDetail) selectedDetail.textContent = remoteAvailabilityState === 'loading'
          ? availabilityMessages[0]
          : availabilityMessages[1];
        submit.textContent = remoteAvailabilityState === 'loading' ? availabilityMessages[2] : availabilityMessages[3];
        submit.disabled = true;
        return;
      }
      if (selectedDetail) {
        selectedDetail.textContent = formatTemplate(selectedFormat === 'virtual' ? virtualDetailTemplate : inPersonDetailTemplate, { time: expectedTime });
      }
      submit.textContent = formatTemplate(submitTemplate, { format: formatLabels[selectedFormat] });
      submit.disabled = false;
    }

    function render() {
      days.innerHTML = '';
      monthLabel.textContent = viewedMonth.toLocaleDateString(undefined, { month: 'long', year: 'numeric' });
      previous.disabled = viewedMonth.getTime() === firstVisibleMonth.getTime();
      next.disabled = viewedMonth.getTime() >= new Date(lastBookableDate.getFullYear(), lastBookableDate.getMonth(), 1).getTime();

      for (var blank = 0; blank < (viewedMonth.getDay() + 6) % 7; blank += 1) {
        var spacer = document.createElement('span'); spacer.setAttribute('aria-hidden', 'true'); days.appendChild(spacer);
      }

      var finalDay = new Date(viewedMonth.getFullYear(), viewedMonth.getMonth() + 1, 0).getDate();
      var remainingReservableDays = 0;
      for (var day = 1; day <= finalDay; day += 1) {
        var date = new Date(viewedMonth.getFullYear(), viewedMonth.getMonth(), day);
        var available = isAvailable(date);
        var selectedDay = isSameDate(date, selectedDate);
        var button = document.createElement('button');
        button.type = 'button'; button.className = 'dsp-demo__day';
        button.dataset.date = toIsoDate(date);
        button.dataset.label = date.toLocaleDateString(undefined, { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' });
        var statusLabel = '';
        if (isSameDate(date, today)) statusLabel = statusLabels[0];
        else if (available) statusLabel = statusLabels[1];
        else if (date >= today && !allowedWeekdays[date.getDay()]) statusLabel = statusLabels[2];
        else if (date >= today && (staticBlockedDates.has(button.dataset.date) || remoteBlockedDates.has(button.dataset.date))) statusLabel = statusLabels[3];
        button.dataset.status = statusLabel.toLowerCase();
        if (available) {
          button.setAttribute('aria-label', selectedDay ? accessibilityLabels[3] + ', ' + button.dataset.label : accessibilityLabels[4] + ' ' + button.dataset.label);
          button.setAttribute('aria-pressed', selectedDay ? 'true' : 'false');
        } else if (statusLabel === statusLabels[2]) button.setAttribute('aria-label', button.dataset.label + ', ' + accessibilityLabels[5]);
        else button.setAttribute('aria-label', button.dataset.label + ', ' + accessibilityLabels[6]);
        var dayNumber = document.createElement('span');
        dayNumber.textContent = day;
        button.appendChild(dayNumber);
        if (statusLabel) {
          var dayStatus = document.createElement('small');
          dayStatus.textContent = statusLabel;
          button.appendChild(dayStatus);
        }

        if (isSameDate(date, today)) {
          button.classList.add('is-today');
          button.setAttribute('aria-current', 'date');
        }
        if (!available) {
          button.disabled = true;
          if (!allowedWeekdays[date.getDay()]) button.title = accessibilityLabels[7];
          if (staticBlockedDates.has(button.dataset.date) || remoteBlockedDates.has(button.dataset.date)) button.title = accessibilityLabels[8];
        } else {
          if (isCurrentMonth()) remainingReservableDays += 1;
          button.addEventListener('click', function () {
            selectedDate = new Date(this.dataset.date + 'T00:00:00');
            if (input) input.value = this.dataset.date;
            render();
            updateSelectionCopy();
          });
        }
        if (selectedDay) button.classList.add('is-selected');
        days.appendChild(button);
      }

      var showNextMonthNudge = isCurrentMonth() && remainingReservableDays <= 5 && !next.disabled;
      next.classList.toggle('is-emphasized', showNextMonthNudge);
      if (nextPrompt) {
        nextPrompt.hidden = !showNextMonthNudge;
        if (showNextMonthNudge) {
          var nextMonth = new Date(viewedMonth.getFullYear(), viewedMonth.getMonth() + 1, 1);
          nextPrompt.textContent = formatTemplate(nextMonthTemplate, { month: nextMonth.toLocaleDateString(undefined, { month: 'long' }) });
        }
      }
    }

    calendar.querySelectorAll('[data-tour-format]').forEach(function (option) {
      option.addEventListener('click', function () { updateFormat(this.dataset.tourFormat); });
    });
    previous.addEventListener('click', function () { viewedMonth.setMonth(viewedMonth.getMonth() - 1); render(); });
    next.addEventListener('click', function () { viewedMonth.setMonth(viewedMonth.getMonth() + 1); render(); });
    if (nextPrompt) nextPrompt.addEventListener('click', function () { viewedMonth.setMonth(viewedMonth.getMonth() + 1); render(); });

    updateFormat(selectedFormat);
    render();

    if (availabilityUrl) {
      var remoteUrl = new URL(availabilityUrl, document.baseURI);
      remoteUrl.searchParams.set('from', toIsoDate(today));
      remoteUrl.searchParams.set('to', toIsoDate(lastBookableDate));
      fetch(remoteUrl.toString(), { headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then(function (response) { if (!response.ok) throw new Error('Availability request failed'); return response.json(); })
        .then(function (payload) {
          remoteBlockedDates = new Set(Array.isArray(payload.blockedDates) ? payload.blockedDates : []);
          remoteAvailabilityState = 'ready';
          if (selectedDate && !isAvailable(selectedDate)) {
            selectedDate = null;
            if (input) input.value = '';
          }
          render();
          updateSelectionCopy();
        })
        .catch(function () {
          remoteAvailabilityState = 'failed';
          calendar.dataset.availabilityState = 'shopify-only';
          updateSelectionCopy();
        });
    }
  });

  document.querySelectorAll('[data-dsp-select-tour-format]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      event.preventDefault();
      var calendar = document.querySelector('[data-dsp-demo-calendar]');
      if (!calendar) return;
      var format = this.dataset.dspSelectTourFormat;
      var option = calendar.querySelector('[data-tour-format="' + format + '"]');
      if (option) option.click();
      calendar.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
});
